import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{topicsData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{topicsData.subtitle}</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {topicsData.items.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="flex items-center gap-2 mb-2">
                <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-500 text-background-50' : item.tag === '新' ? 'bg-accent-500 text-background-50' : 'bg-secondary-500 text-background-50'
                }`}>
                  {item.tag}
                </span>
                <span className="text-[10px] text-foreground-500">{item.heat}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer">
                # {item.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}